// Helper functions
const priceToInt = product => {
    return parseInt(product.variants[0].price.replace(".", ""));
};

const intToPrice = price => {
    return `$${(price / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
};

const getters = {
    // Product getters
    canderCards(state) {
        return state.canderCards;
    },

    addonProducts(state) {
        return state.addonProducts;
    },

    individualProducts(state) {
        return state.selectedIndividualAddons;
    },

    boxProducts(state) {
        return state.mainProducts;
    },

    selectedBoxProduct(state) {
        return state.selectedMainProduct;
    },

    cardProducts(state) {
        return state.cardProducts;
    },

    selectedCardProduct(state) {
        return state.selectedCardProduct;
    },

    savedCardProduct(state) {
        return state.savedCardProduct;
    },

    savedKey(state) {
        return state.savedKey;
    },

    // Filter and occasion getters
    occasions(state) {
        return state.occasions;
    },

    categories(state) {
        return state.categories;
    },

    selectedOccasion(state) {
        return state.selectedOccasion;
    },

    selectedCategories(state) {
        return state.selectedCategories;
    },

    selectedSort(state) {
        return state.selectedSort;
    },

    selectedFilters(state) {
        return state.selectedFilters;
    },

    rangePrice(state) {
        return state.rangePrice;
    },

    selectedCardsOccasions(state) {
        return state.selectedCardsOccasions;
    },

    // Mobile filter getters
    selectedOccasionMobile(state) {
        return state.selectedOccasionMobile;
    },

    selectedCategoriesMobile(state) {
        return state.selectedCategoriesMobile;
    },

    selectedSortMobile(state) {
        return state.selectedSortMobile;
    },

    selectedFiltersMobile(state) {
        return state.selectedFiltersMobile;
    },

    rangePriceMobile(state) {
        return state.rangePriceMobile;
    },

    selectedCardsOccasionsMobile(state) {
        return state.selectedCardsOccasionsMobile;
    },

    // Box configuration getters
    maxCapacity(state) {
        return state.maxCapacity;
    },

    currentCapacity(state) {
        return state.selectedAddonProducts
            .filter(x => !x.tags.some(tag => tag.includes("Overflow_trigger")))
            .map(x => (x.capacity ? x.capacity * x.quantity : 0))
            .reduce((prev, next) => prev + next, 0);
    },

    boxQty(state) {
        return state.boxQty;
    },

    productLimit(state) {
        return state.productLimit;
    },

    boxName(state) {
        return state.boxName;
    },

    defaulBoxName(state) {
        return state.defaulBoxName;
    },

    cartNames(state) {
        return state.cartNames;
    },

    // Cart and utility getters
    cartQty(state) {
        return state.cartQty;
    },

    feeProduct(state) {
        return state.feeProduct;
    },

    isPage(state) {
        return state.isPage;
    },

    multishipCallout(state) {
        return state.multishipCallout;
    },

    cardHasMessage(state) {
        return state.cardHasMessage;
    },

    showCardAlert(state) {
        return state.showCardAlert;
    },

    // Computed getters
    selectedAddonProducts(state) {
        return state.selectedAddonProducts;
    },

    totalBuildPrice(state) {
        let totalPrice = 0;
        const mainProduct = state.selectedMainProduct;
        const addonProducts = state.selectedAddonProducts;
        const cardProduct = state.selectedCardProduct;

        if (mainProduct?.variants) {
            totalPrice += priceToInt(mainProduct);
        }

        if (addonProducts.length > 0) {
            addonProducts.forEach(addon => {
                totalPrice += priceToInt(addon) * addon.quantity;
            });
        }

        if (cardProduct?.variants) {
            totalPrice += priceToInt(cardProduct);
        }

        return intToPrice(totalPrice);
    },

    addCopy(state) {
        return state.boxQty > 1 ? "Add to Each Box" : "Add to Box";
    },

    isLoading(state) {
        return state.isLoading;
    }
};

export default getters;
